import { useAppStore } from "@hooks/useAppStore";
import { useSessionAnalysis } from "@memorang/features/src/session-analysis/hooks/useSessionAnalysis";
import type { ReportDetails } from "@memorang/types";
import { SessionTipSlotView } from "./SessionTipSlotView";

type Props = {
	reportDetails: ReportDetails;
	examId: string;
	appId: string;
	tenantName: string;
	outputLanguage: string;
	previewText: string;
	isLoading: boolean;
	isError: boolean;
	handleTracking: (
		eventName: string,
		params?: Record<string, string | number>,
	) => void;
};

export const SessionTipSlot = ({
	reportDetails,
	examId,
	appId,
	tenantName,
	outputLanguage,
	previewText,
	isLoading,
	isError,
	handleTracking,
}: Props) => {
	const sessionAnalysisEnabled = Boolean(
		useAppStore((s) => s.reportView?.ai?.sessionAnalysis),
	);

	const { sessionAnalysis, loading, streaming } = useSessionAnalysis({
		sessionId: Number(reportDetails.id),
		examName: reportDetails.examName,
		tenantName,
		outputLanguage,
		examId,
		appId,
	});

	const showSessionAnalysis =
		Boolean(examId) &&
		Boolean(reportDetails) &&
		!reportDetails?.isMigratedProgress &&
		sessionAnalysisEnabled;

	return (
		<SessionTipSlotView
			reportDetails={reportDetails}
			tenantName={tenantName}
			outputLanguage={outputLanguage}
			preview={{ text: previewText, isLoading, isError }}
			fullReport={{
				data: sessionAnalysis,
				isLoading: loading,
				streaming,
				canOpen: showSessionAnalysis,
			}}
			handleTracking={handleTracking}
		/>
	);
};
